import React, { Ref } from 'react';
import styles from './scss/contentlayout.module.scss';

import { useEffect, useRef } from 'react';

interface layoutProps {
    children: React.ReactNode;
    noPadding?: boolean;
    noPaddingBlock?: boolean;
    scrollset?: boolean;
}

const ContentLayout = ({ children, noPadding = false, noPaddingBlock = false, scrollset = false }: layoutProps) => {

    return (
        <div className={`${styles.contentlayout} contentmain ${noPaddingBlock ? styles.nopaddingblock : ''} ${noPadding ? styles.nopadding : ''} ${scrollset ? styles.scrollset : ''}`}>
            {children}
        </div>
    )
}

export default ContentLayout
